<template>
	<div class="contractSign" ref="contractSign">
		<el-dialog :title="title" :visible.sync="dialog.show" :width="width" @close="handclose" center top="1vh"
			:close-on-click-modal="false"  id="lz-dialog-lz">
			<div class="center"  v-loading="dialog.loading" style="position: relative;">
				<div class="c-left">
					<lzHeader icon="el-icon-s-claim" title="我的印章" remark="可拖动至合同上"></lzHeader>
					<div class="item-li" v-for="(item,index) in draggable.list" :key="index" draggable @dragstart="dragStart" @dragend="dragEnd($event,item.id)">
						<img class="image" :src="item.url" />
					</div>
					<div class="checkboxList">
						<div class="cl-top">
							<el-checkbox v-model="checkbox.checkAll" @change="checkAllChange" style="margin: 10px 0;">全选</el-checkbox>
							<el-checkbox-group v-model="checkbox.checkList">
								<el-checkbox :checked="item.isUse==true" v-for="(item,index) in sealList" :label="index" :key="index" v-if="index!=0">
									<div style="width: 60px;" @click.prevent="pageChange(index)">第{{index}}页 
										<span v-if="item.isUse==true" class="usertrue" >
											已盖章
										</span>
									</div>
								</el-checkbox>
							</el-checkbox-group>
						</div>
						<div style="margin-bottom: 15px;">
							<el-checkbox v-model="paging.checked" >骑缝章</el-checkbox>
							<template v-if="paging.checked">
								<el-form ref="ruleForm" label-width="80px" label-position="left">
									<el-form-item label="左右位置" prop="left">
										<el-radio-group v-model="paging.left">
										    <el-radio :label="0">左边</el-radio>
										    <el-radio :label="$refs.pdfCanvas.width-26">右边</el-radio>
										  </el-radio-group>
									</el-form-item>
								</el-form>
							</template>
						</div>
						<div >
							<el-button type="warning" size="mini" @click="delElectronSealAll()" :disabled="checkbox.checkList.length==0">清除所选签章</el-button>
							<el-button type="primary" size="mini" @click="oneTouch()" :disabled="checkbox.checkList.length==0">一键生成签章</el-button>
						</div>
					</div>
				</div>
				<div class="c-center">
					<div class="center-btn">
						<div>
							<el-button type="warning" size="mini" @click="delElectronSeal()">清除当前签章</el-button>
						</div>
						<div>
							<el-button type="primary" size="mini" @click="prevPage" :disabled="pdf.page.pageNum==1">上一页</el-button>
							<el-button type="primary" size="mini" @click="nextPage" :disabled="pdf.page.total==pdf.page.pageNum">下一页</el-button>
							<el-button type="primary" size="mini" style="padding: 5px 15px;">
							<input class="lz-input" ref="lzInput" :value="pdf.page.pageNum" @change="lzInputChange()" type="number"></input>
							/{{pdf.page.total}}</el-button>
						</div>
					</div>
					<!-- 渲染pdf的地方 -->
					<canvas ref="pdfCanvas" id="pdfCanvas"></canvas>
					<!-- 渲染印章 -->
					<div class="c-cter" >
						<!-- 渲染自己可拖动的电子章 -->
						<canvas ref="sealCavas" id="sealCavas" ></canvas>
						
						<!-- 渲染其他签署方签署的印章 -->
						<template v-if="contractInfo&&contractInfo.signedList">
							<div v-for="(item,index) in contractInfo.signedList" :key="index" v-if="item.signContent[pdf.page.pageNum].isUse==true">
								<div class="other-cter" v-for="(sl,si) in item.signContent[pdf.page.pageNum].sealArr" :key="si"   :style="{position:'absolute',left:sl.left+'px',top:sl.top+'px'}">
									<img :src="'data:image/png;base64,'+item.sealImageData" :style="{width: item.signContent[pdf.page.pageNum].width+'px',height:item.signContent[pdf.page.pageNum].height+'px'}"/>
								</div>
							</div>
						</template>
						<!-- 骑缝章滑块 -->
						<div v-if="paging.checked&&applicationCoveredNum>0" ref="pagingSeal" class="pagingSeal" 
						:style="{top: paging.top  + 'px', left: paging.left  + 'px'}"  @mousedown="onButtonDown">
							骑缝章
						</div>
					</div>
				</div>
				<div class="c-right">
					<div class="r-top">
						<el-link type="primary" :underline="false">基本信息</el-link>
						<lz-row-col label="申请单名称：" >{{ contractInfo.title }}</lz-row-col>
						<lz-row-col label="合同编号：" >{{ contractInfo.serialNumber }}</lz-row-col>
						<lz-row-col label="合同状态：" ><el-tag :type="computedTypeId(contractInfo.signStatus)" size="mini">{{computedTypeId(contractInfo.signStatus,'text')}}</el-tag></lz-row-col>
						<lz-row-col label="截止日期：" >{{ contractInfo.expireTime }}</lz-row-col>
						<lz-row-col label="创建日期：" >{{ contractInfo.createDate }}</lz-row-col>
						<lz-row-col label="加盖次数：" > <el-tag size="mini">{{ contractInfo.applicationTotalNum }}次</el-tag> </lz-row-col>
						<lz-row-col label="已盖次数：" ><el-tag size="mini" type="success">{{ applicationCoveredNum }}次</el-tag></lz-row-col>
						
					</div>
					<div class="r-center">
						<el-link type="primary" :underline="false">签署步骤</el-link>
						<lz-row-col label="1.">把印章拖到需要的位置上</lz-row-col>
						<lz-row-col label="2.">点击"签署"</lz-row-col>
					</div>
					<div class="r-bottom">
						<el-link type="primary" :underline="false" style="margin-bottom: 20px;">操作 
						<span style="color: #E6A23C;" v-if="contractInfo.signStatus=='confirmed'">{{contractInfo.authorizeType=='ca'?'实体印章CA已授权，可直接签署':'经办人已短信授权，可直接签署'}}</span></el-link>
						
						<div>
							<el-button type="primary" size="mini" @click="singFn">签署</el-button>
							<el-button type="warning" size="mini" @click="handclose">关闭</el-button>
							<el-button type="primary" size="mini" @click="preservation">保存</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
		<lzVerificationCode :seconds="code.seconds" ref="uCode" @change="verificationChange" :keep-running="true"></lzVerificationCode>
		<el-dialog title="印章管理员短信授权" :visible.sync="code.show" width="400px"  :close-on-click-modal="false">
			<div v-loading="code.loading" style="overflow: hidden;">
				<div>合同编号：<el-link type="primary">{{contractInfo.serialNumber}}</el-link></div>
				<div class="operate">
					<el-input placeholder="请输入验证码" size="mini" v-model="code.checkCode" style="width: 200px;margin-right: 20px;"></el-input>
					<el-button type="primary" size="mini" @click="sendVerCode()">{{code.tips}}</el-button>
				</div>
				<el-alert v-if="contractInfo&&contractInfo.transactorUser"
				    :title="`【验证码】将发送给印章管理员【${contractInfo.transactorUser}】${contractInfo.transactorPhone}`"
				    type="info" :closable="false">
				</el-alert>
				<div class="operatefoot" style="float: right;margin-top: 30px;">
					<el-button  @click="code.show=false" size="mini">取 消</el-button>
					<el-button  type="primary" @click="confirmVerCode()" size="mini">签 署</el-button>
				</div>
			</div>
		</el-dialog>
		
		<el-dialog title="智能印章设备授权" :visible.sync="CA.show" width="500px"  :close-on-click-modal="false">
			<div style="overflow: hidden;">
				<div class="start" v-if="CA.animate">
					<img :src="CA.src" />
				</div>
				<template v-else>
					<div class="start" v-if="contractInfo.signStatus=='confirmed'">
						<img :src="CA.src" />
					</div>
					<div class="operate" v-else>
						<el-descriptions :column="2" border style="width: 100%;">
						    <el-descriptions-item label="实体章名">{{contractInfo.device}}</el-descriptions-item>
						    <el-descriptions-item label="在线状态">{{device.online==true?'在线':'离线'}}</el-descriptions-item>
						    <el-descriptions-item label="授权状态">{{contractInfo.signStatus=='confirmed'?'已授权':'未授权'}}</el-descriptions-item>
						    <el-descriptions-item label="请求授权" v-if="contractInfo.signStatus!='confirmed'"><el-button type="success" @click="applyCaAuthorized()" size="mini">请求授权</el-button></el-descriptions-item>
						</el-descriptions>
					</div>
				</template>
				
				<div class="operatefoot" style="float: right;margin-top: 30px;">
					<el-button  @click="closeVerCode" size="mini">取 消</el-button>
					<el-button  type="primary" :disabled="contractInfo.signStatus!='confirmed'" @click="sendSingFn()" size="mini">签 署</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	let that
	import lzRowCol from '@/components/lzRowCol/lzRowCol'
	import lzHeader from '@/components/lzHeader/lzHeader';
	import lzVerificationCode from '@/components/lzVerificationCode/lzVerificationCode';
	// import * as PdfJs from 'pdfjs-dist/build/pdf.js' // 注意导入的写法
	// PdfJs.GlobalWorkerOptions.workerSrc = require('pdfjs-dist/build/pdf.worker.entry')
	import {
		mapGetters
	} from 'vuex'

	export default {
		computed: {
			...mapGetters(['api','userInfo','contractStatusList']),
			computedTypeId() {
				return (typeId,type) => {
					let arr = this.contractStatusList.find(item => item.key == typeId)
					if (arr) {
						return type=='text'? arr.value : arr.color
					} else {
						return  type=='text'? '待定' : 'info' 
					}
				}
			}
		},
		components: {
			lzHeader,
			lzRowCol,
			lzVerificationCode
		},
		name: 'contractSign',
		props: {
			close: {
				type: Function
			},
			confirm: {
				type: Function
			},
			cancel: {
				type: Function
			},
			width: {
				type: String,
				default: '90%'
			},
			title: {
				type: String,
				default: '选择'
			},
			//企业合同
			enterpriseApplicationId: {
				type: String,
				default: ''
			}
		},
		watch:{
			$route(to, from) {
				console.log(to, from);
			}
		},
		data() {
			return {
				pdf: {
					isRendering: false, //是否正在渲染
					pageNumPending: null,
					scale: 1, //渲染内容比例（ 放大倍数）
					url: '',
					doc: null,
					page: {
						pageNum: 1, //当前页数
						total: 0 // 总页数
					}
				},
				// 当前页面渲染的印章电子图片
				sealImage: {
					canvas: null,//当前电子印章画布
				},
				dialog: {
					show: false,
					loading:false,
				},
				draggable: {
					list: []
				},
				//每个页面的电子章的信息
				sealList:[],
				//获取到的企业合同信息
				contractInfo:{},
				applicationCoveredNum:0,//已盖次数
				//验证码
				code:{
					checkCode:'',
					show:false,
					seconds:60,
					tips: '',
					loading:false
				},
				//多选
				checkbox:{
					checkAll: false,//是否全选
					checkList:[],//已选数据
				},
				//ca授权
				CA:{
					show:false,
					animate:false,//是否开启动画
					uuid:'',//定时请求需要参数
					title:'等待印章确认',
					timer:null,//定时器
					src:'../../../static/img/seal/seal2.png'
				},
				//骑缝章
				paging:{
					checked:false,//是否选择骑缝章
					flags: false,//拖动开始
					top:0,
					left:0,
					scrollHeight:0,
					position:{
						x:0,
						y:0,
						left:0,
						top:0
					}
				},
				// 设备在线状态
				device:{
					timer:null,//定时器
					online:false,//是否在线
				}
			}
		},
		mounted() {
			that = this
		},
		methods: {
			//定时请求在线状态
			setTime(){
				if(this.device.timer)clearInterval(this.device.timer);
				this.device.timer=setInterval(()=>{
					this.findDeviceInfo()
				},5000)
			},
			//获取实体章的在线状态
			findDeviceInfo(){
				that.GLOBAL.doGet(this.api.GLOBAL_device_signet_findDeviceInfo+'/'+this.contractInfo.deviceId, {}, (res) => {
					if (res.code == 200) {
						this.device.online=res.data.online
						//启用定时请求
						that.setTime()
					}else{
						clearInterval(this.device.timer)
					}
				})
			},
			//骑缝章移动
			onButtonDown(event){
				event.preventDefault();
				//开始移动
				this.pagingSealMouseDown(event);
				//监听事件
				window.addEventListener('mousemove', this.pagingSealMouseMove);
				window.addEventListener('touchmove', this.pagingSealMouseMove);
				window.addEventListener('mouseup', this.pagingSealMouseUp);
				window.addEventListener('touchend', this.pagingSealMouseUp);
				window.addEventListener('contextmenu', this.pagingSealMouseUp);// 右击鼠标时执行 
			},
			pagingSealMouseDown(event){
				this.paging.flags = true
				const refs = this.$refs.pagingSeal.getBoundingClientRect()
				this.paging.scrollHeight=document.getElementById('lz-dialog-lz').scrollTop
				this.paging.position.x = event.clientX
				this.paging.position.y = event.clientY
				this.paging.position.left = refs.left
				this.paging.position.top = refs.top
			},
			pagingSealMouseMove(e){
				if(this.paging.flags){
					const xPum = this.paging.position.left + e.clientX - this.paging.position.x
					const yPum = this.paging.position.top + e.clientY - this.paging.position.y + this.paging.scrollHeight
					this.paging.top= yPum-92
					this.banOut()
				}
			},
			pagingSealMouseUp(event){
				this.paging.flags = false
				this.banOut()
				window.removeEventListener('mousemove', this.pagingSealMouseMove);
				window.removeEventListener('touchmove', this.pagingSealMouseMove);
				window.removeEventListener('mouseup', this.pagingSealMouseUp);
				window.removeEventListener('touchend', this.pagingSealMouseUp);
				window.removeEventListener('contextmenu', this.pagingSealMouseUp);// 右击鼠标时执行
			},
			//避免拖动出界的限制
			banOut () { 
			  const refs = this.$refs.pagingSeal.getBoundingClientRect()
				if (this.paging.top < 0) {
					this.paging.top = 0
				}else if (this.paging.top > this.$refs.pdfCanvas.height - refs.height ){
					this.paging.top = this.$refs.pdfCanvas.height - refs.height
				}
			},
			
			//启用定时请求
			initTime(){
				if(this.CA.timer)clearInterval(this.CA.timer);
				this.CA.timer=setInterval(()=>{
					this.findAuthorized()
				},5000)
			},
			findAuthorized(){
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_enterprise_application_findAuthorized, {enterpriseApplicationId:this.enterpriseApplicationId,uuid:that.CA.uuid}, (res) => {
					if (res.code == 200) {
						// (ACK回调) 0成功 1失败  2印章正在使用中 3指纹识别超时 4证书不存在
						if(res.data==0){
							that.CA.animate=false
							that.contractInfo.signStatus='confirmed'
							that.CA.src='../../../static/img/seal/seal.png'
							clearInterval(that.CA.timer);
						}else if(res.data==1){
							that.CA.animate=false
							that.$message.success('失败')
							that.CA.src='../../../static/img/seal/seal2.png'
							clearInterval(that.CA.timer);
						}else if(res.data==2){
							that.CA.animate=false
							that.$message.success('印章正在使用中')
							that.CA.src='../../../static/img/seal/seal2.png'
							clearInterval(that.CA.timer);
						}else if(res.data==3){
							that.CA.animate=false
							that.$message.success('指纹识别超时')
							that.CA.src='../../../static/img/seal/seal2.png'
							clearInterval(that.CA.timer);
						}else if(res.data==4){
							that.CA.animate=false
							that.$message.success('证书不存在')
							that.CA.src='../../../static/img/seal/seal2.png'
							clearInterval(that.CA.timer);
						}
						
					}else{
						clearInterval(that.CA.timer);
					}
				})
			},
			//请求授权
			applyCaAuthorized(){
				that.CA.uuid=''
				that.GLOBAL.doPost(this.api.GLOBAL_electronic_enterprise_application_applyCaAuthorized+'/'+this.enterpriseApplicationId, {}, (res) => {
					if (res.code == 200) {
						that.CA.animate=true
						that.CA.uuid=res.data
						that.$message.success(res.msg)
						//启用定时请求
						that.initTime()
					}
				})
			},
			//关闭授权窗口
			closeVerCode(){
				that.CA.animate=false
				that.CA.show=false
				clearInterval(that.CA.timer);
				clearInterval(that.device.timer);
			},
			//清空所选
			delElectronSealAll(){
				let indexArr= this.checkbox.checkList
				this.sealList = this.sealList.map((item)=>{
					if(indexArr.includes(item.index)){
						item.isUse=false
						item.sealArr=[]
					}
					return item
				})
				//设置已盖次数
				this.setPageNum()
				this.checkbox.checkList=[]
				this.checkbox.checkAll=false
				//清空电子章画布
				if(indexArr.includes(this.pdf.page.pageNum)){
					this.sealImage.canvas.clear()
				}
				this.$message.success('清空所选完成')
			},
			//删除当前页电子章
			delElectronSeal(){
				let index=this.pdf.page.pageNum
				this.sealList[index].isUse=false
				this.sealList[index].sealArr=[]
				this.sealImage.canvas.clear()
				//设置已盖次数
				this.setPageNum()
			},
			//一键生成盖章
			oneTouch(){
				let index=this.pdf.page.pageNum
				let indexArr= this.checkbox.checkList.filter(item=>item!=0)
				let num=indexArr.length
				//当前页面盖了多少章
				let useNum=this.sealList[index].sealArr.length
				//先判断下当前盖章是否超出次数
				if(num*useNum>this.contractInfo.applicationTotalNum){
					this.$message.warning('超出盖章次数')
					// indexArr=indexArr.slice(0,this.contractInfo.applicationTotalNum)
					// num=parseInt(this.contractInfo.applicationTotalNum)
					return
				}
				//判断当前页面的电子印章是否存在，如果存在（以当前印章所在位置，一键生成所有页面）
				
				let obj=JSON.parse(JSON.stringify(this.sealList[index]))
				delete obj.index
				console.log(obj);
				if(obj.isUse==true){
					this.sealList = this.sealList.map((item,index)=>{
						if(item){
							if(indexArr.includes(item.index)){
								obj.sealArr=obj.sealArr.map(position=>{
									position.uuid=this.$lizhao.guid()
									return position
								})
								item={
									index:item.index,
									...obj
								}
							}else{
								item.isUse=false
							}
						}
						return item
					})
					//设置已盖次数
					this.setPageNum()
					this.$message.success('生成完成')
					//如果拖动的当前页不是要生成的电子印章页则清除画布
					if(!indexArr.includes(index)){
						//清空电子章画布
						this.sealImage.canvas.clear()
					}
				}else{
					this.$message.warning('请指定盖章位置，以便生成')
				}
			},
			//全选变化
			checkAllChange(val) {
				if(val){
					this.checkbox.checkList =this.sealList.map(item=>item.index)
				}else{
					this.checkbox.checkList = [];
				}
			},
			//check跳转页数
			pageChange(num){
				this.pdf.page.pageNum=parseInt(num)
				//清空电子章画布
				this.sealImage.canvas.clear()
				//渲染pdf
				this.renderPage();
			},
			//跳转页数
			lzInputChange(){
				if(this.$refs.lzInput.value>this.pdf.page.total){
					this.$refs.lzInput.value=JSON.parse(JSON.stringify(this.pdf.page.pageNum))
				}else if(this.$refs.lzInput.value<0||this.$refs.lzInput.value==0){
					this.$refs.lzInput.value=JSON.parse(JSON.stringify(this.pdf.page.pageNum))
				}else{
					this.pdf.page.pageNum=parseInt(this.$refs.lzInput.value)
					//清空电子章画布
					this.sealImage.canvas.clear()
					//渲染pdf
					this.renderPage();
				}
			},
			//发送验证码
			sendVerCode(){
				if(this.$refs.uCode.canGetCode) {
					that.GLOBAL.doPost(this.api.GLOBAL_electronic_message_authenticationCode_sendSMSAuthenticationCode+'/'+this.enterpriseApplicationId, {}, (res) => {
						if (res.code == 200) {
							that.$refs.uCode.start();
							that.$message.success(res.msg)
						}
					})
				}else{
					this.$message.warning('倒计时结束后再发送')
				}
			},
			verificationChange(text){
				this.code.tips = text
			},
			//确定验证码
			confirmVerCode(){
				if(!this.code.checkCode){
					this.$message.warning('请填写验证码')
					return
				}
				this.code.loading=true
				let codeReq={
					emulateJSON:false,// emulateJSON为前端需要参数
					checkCode: this.code.checkCode,
					enterpriseApplicationId: this.enterpriseApplicationId
				}
				that.GLOBAL.doPost(this.api.GLOBAL_electronic_message_authenticationCode_verifySMSAuthenticationCode, codeReq, (res) => {
					if (res.code == 200) {
						//发送签署
						that.sendSingFn()
					}else{
						this.code.loading=false
						that.$message.warning(res.msg)
					}
				})
			},
			//发送签署
			sendSingFn(){
				//过滤出哪些页面盖了电子章
				let arr=[]
				this.sealList.forEach(item=>{
					if(item&&item.isUse==true&&item.index!=0){
						item.sealArr.forEach(sl=>{
							let obj={
								signLocationLBX:sl.aCoords.bl.x,
								signLocationLBY:sl.aCoords.bl.y,
								signLocationRUX:sl.aCoords.tr.x,
								signLocationRUY:sl.aCoords.tr.y,
								signOnPage:item.index
							}
							arr.push(obj)
						})
					}
				})
				let req={
					emulateJSON:false,// emulateJSON为前端需要参数
					authorizationTime:this.$lizhao.timeFormat(new Date().getTime()) ,//授权时间,用户输入验证码的时间
					enterpriseApplicationId:this.enterpriseApplicationId,//企业合同id
					signLocations:arr,
					signContent:JSON.stringify(this.sealList),
					signTotal:parseInt(this.applicationCoveredNum),
					width:this.$refs.pdfCanvas.width,
					height:this.$refs.pdfCanvas.height,
				}
				//骑缝章
				if(this.paging.checked&&this.applicationCoveredNum>0){
					req.crossPage={
						crossPageStyle:this.paging.left==0 ? 1 : 2,
						offsetCoordY:this.$refs.pdfCanvas.height - this.paging.top - 150
					}
				}
				that.GLOBAL.doPost(this.api.GLOBAL_electronic_enterprise_contract_sign, req, (res) => {
					this.code.loading=false
					if (res.code == 200 ) {
						that.code.show=false
						that.$refs.uCode.reset();
						that.$message.success(res.msg)
						//确定
						that.submitFn() 
					}else{
						that.$message.warning(res.msg)
					}
				})
			},
			//签署
			singFn(){
				//过滤出哪些页面盖了电子章
				let arr= this.sealList.filter(item=>item&&item.isUse==true)
				if(arr&&arr.length>0){
					if(this.contractInfo.authorizeType=='ca'){
						//如果授权人选择了CA验证，则需要下发指令给实体章确认，
						if(this.contractInfo.signStatus=='confirmed'){
							this.$confirm('是否确认签署?', '提示', {
							  confirmButtonText: '确定',
							  cancelButtonText: '取消',
							  type: 'warning'
							}).then(() => {
								//发送签署
								that.sendSingFn()
							}).catch(() => {
							         
							});
						}else{
							this.CA.show=true
							//获取在线状态
							this.findDeviceInfo()
						}
					}else if(this.contractInfo.authorizeType=='sms'){
						//如果是短信sms，则需要经办人验证码 confirmed代表已经授权
						if(this.contractInfo.signStatus=='confirmed'){
							this.$confirm('是否确认签署?', '提示', {
							  confirmButtonText: '确定',
							  cancelButtonText: '取消',
							  type: 'warning'
							}).then(() => {
								//发送签署
								that.sendSingFn()
							}).catch(() => {
							         
							});
						}else{
							this.code.show=true
						}
						
					}
				}else{
					this.$message.warning('请先加盖电子印章')
				}
				
				
			},
			// 上一页
			prevPage() {
				if (this.pdf.page.pageNum <= 1) {
					return;
				}
				//清空电子章画布
				this.sealImage.canvas.clear()
				this.pdf.page.pageNum--;
				//渲染pdf
				this.renderPage();
			},
			//下一页
			nextPage() {
				if (this.pdf.page.pageNum >= this.pdf.page.total) {
					return;
				}
				//清空电子章画布
				this.sealImage.canvas.clear()
				this.pdf.page.pageNum++;
				//渲染pdf
				this.renderPage();
			},
			//限制拖动区域（此为对象坐标原点设置在中心的情况）
			checkBoudningBox(e) {
				let index=this.pdf.page.pageNum
				const obj = e.target
				if (!obj) {
					return
				}
				obj.setCoords()
				const objBoundingBox = obj.getBoundingRect()
				//记录数据
				let sealInfo=JSON.parse(JSON.stringify(this.sealList[index]))
				console.log(sealInfo);
				sealInfo.sealArr=sealInfo.sealArr.map(sealItem=>{
					if(sealItem.uuid==obj.uuid){
						sealItem.aCoords=obj.aCoords
						sealItem.left=objBoundingBox.left
						sealItem.top=objBoundingBox.top
						if (objBoundingBox.top < 0) {
							obj.set('top', 0)
							obj.setCoords()
							sealItem.top=0
						}
						if (objBoundingBox.left > this.sealImage.canvas.width - objBoundingBox.width) {
							obj.set('left', this.sealImage.canvas.width - objBoundingBox.width)
							obj.setCoords()
							sealItem.left=this.sealImage.canvas.width - objBoundingBox.width
						}
						if (objBoundingBox.top > this.sealImage.canvas.height - objBoundingBox.height) {
							obj.set('top', this.sealImage.canvas.height - objBoundingBox.height)
							obj.setCoords()
							sealItem.top=this.sealImage.canvas.height - objBoundingBox.height
						}
						if (objBoundingBox.left < 0) {
							obj.set('left', 0)
							obj.setCoords()
							sealItem.left=0
						}
					}
					return sealItem
				})
				this.sealList[index]=sealInfo
				//限制电子印章的放大，最大400px
				if(objBoundingBox.width>400){
					obj.scaleToWidth(400); 
				}
				if(objBoundingBox.height>400){
					obj.scaleToWidth(400); 
				}
			},
			// 生成绘图区域
			renderFabric() {
				//判断当前cavas是否已经创建，创建过则直接绘制印章
				if(this.sealImage.canvas){
					// 添加公章
					this.addSeal()
					return
				}
				let index=this.pdf.page.pageNum
				let pdfCanvas = this.$refs.pdfCanvas;
				let sealCavas = this.$refs.sealCavas;
				sealCavas.height = pdfCanvas.height; //返回内容高度
				sealCavas.width = pdfCanvas.width; //返回内容宽度
				this.sealImage.canvas = new fabric.Canvas(sealCavas);
				//监听旋转拖动和放大，限制可拖动的区域
				this.sealImage.canvas.on('object:moving', function(e) {
					
					that.checkBoudningBox(e)
				})
				this.sealImage.canvas.on('object:rotating', function(e) {
					that.checkBoudningBox(e)
				})
				this.sealImage.canvas.on('object:scaling', function(e) {
					that.checkBoudningBox(e)
				})
				// 添加公章
				this.addSeal()
			},
			// 添加公章
			addSeal() {
				let index=this.pdf.page.pageNum
				let item=this.sealList[index]
				//判断当前页面有没使用电子章，使用了就显示出来
				if(item&&item.isUse==true){
					item.sealArr.forEach((position,sIndex)=>{
						let image=this.draggable.list.find(img=>img.id==position.imageId)
						this.addFabric(item,position,image.url)
					})
					
				}else{
					//清空电子章画布
					this.sealImage.canvas.clear()
				}
			},
			/**
			 * item为当前页的所有参数，
			 * position为每个章的定位信息
			 * img为当前电子章的图片信息
			 * **/ 
			addFabric(item,position,img,imageId){
				fabric.Image.fromURL(img, (oImg) => {
					oImg.set({
						left: position.left,
						top: position.top,
						scaleX: 1,
						scaleY: 1,
						imageId:position.imageId,
						uuid:position.uuid
					});
					oImg.setControlsVisibility({
					    mt:false, 
					    mb:false, 
					    ml:false,
					    mr:false, 
						tl:false,
						tr:false,
						bl:false,
						br:false,
						mtr:false, 
					})
					//设置图片宽高
					oImg.scaleToWidth(item.width); 
					oImg.scaleToHeight(item.height); 
					this.sealImage.canvas.add(oImg);
				});
			},
			// 初始化pdf
			initPdf() {
				this.dialog.loading=true
				pdfjsLib.getDocument(this.pdf.url).promise.then((pdfDoc_) => {
					this.dialog.loading=false
					this.isLoading = false;
					// 返回pdf实例 getDocument
					this.pdf.doc = pdfDoc_;
					// 返回总页数
					this.pdf.page.total = this.pdf.doc.numPages;
					this.pdf.page.pageNum = 1;
					//处理服务端返回数据
					this.processingData()
					//渲染pdf
					this.renderPage();
				}).catch((err) => {
					console.log(err);
					this.dialog.loading=false
					if(err.message=="Failed to fetch"){
						this.$message.warning('无法获取PDF内容')
						this.dialog.show=false
						return
					}
					this.$confirm('未知错误,需要刷新页面', 'PDF解析失败', {
					  confirmButtonText: '确定',
					  showCancelButton:false,
					  // showClose:false,
					  closeOnClickModal:false,
					  type: 'warning'
					}).then(() => {
						location.reload();
					}).catch(() => { 
					});
				});
			},
			//处理服务端返回数据
			processingData(){
				//判断用户有没有保存过电子印章，如果有则显示之前保存的，如果没有则生成
				if(this.contractInfo&&this.contractInfo.signContent){
					this.sealList=JSON.parse(this.contractInfo.signContent)
					console.log(this.sealList);
					//设置已盖次数
					this.setPageNum()
				}else{
					//初始化每个页都生成一个虚拟电子章
					this.setElectronicSeal()
				}
			},
			//初始化每个页都生成一个虚拟电子章
			setElectronicSeal(){
				let arr=[]
				for (var i = 0; i < this.pdf.page.total+1; i++) {
					arr.push({
						index:i,
						isUse:false,//当前页面是否盖章了
						width: 150,//电子章的宽高
						height: 150,
						scale:1,
						sealArr:[],//当前页面盖的电子章数量位置
					})
				}
				this.sealList=arr
			},
			// 渲染pdf
			renderPage() {
				//正在渲染
				this.pdf.isRendering = true;
				let canvas = this.$refs.pdfCanvas;
				this.pdf.doc.getPage(this.pdf.page.pageNum).then((page) => {
					// 返回页面内容(比例) page.getViewport(scale)
					var viewport = page.getViewport({
						scale: this.pdf.scale
					});
					canvas.height = viewport.height; //返回内容高度
					canvas.width = viewport.width; //返回内容宽度
					let ctx = canvas.getContext("2d")
					var renderContext = {
						canvasContext: ctx, //画布
						viewport: viewport, //内容
					};
					// 页面呈现({画布,内容}) page.render(renderContext);
					var renderTask = page.render(renderContext);
					renderTask.promise.then(() => {
						//预渲染电子印章
						that.renderFabric()
						this.pdf.isRendering = false;
					});
				});
			},
			//拖拽开始
			dragStart(e) {
				//鼠标按下去的位置
				let {x,y}=e.target.getBoundingClientRect()
				e.target.lzX=e.pageX-x
				e.target.lzY=e.pageY-y
			},
			//拖拽结束
			dragEnd(e,imageId) {
				//判断盖章次数是否超过
				if(this.applicationCoveredNum> that.contractInfo.applicationTotalNum||this.applicationCoveredNum== that.contractInfo.applicationTotalNum){
					this.$message.warning('超出盖章次数')
					return 
				}else{
					//清空电子章画布
					this.sealImage.canvas.clear()
					let index=this.pdf.page.pageNum
					//获取摸个元素的坐标位置getBoundingClientRect
					let {x,y,width,height}= this.$refs.sealCavas.getBoundingClientRect()
					// console.log('结束位置',e.pageX,e.pageY);
					// console.log('结束元素左上角位置',e.pageX-e.target.lzX,e.pageY-e.target.lzY);
					let originX=e.pageX-e.target.lzX
					let originY=e.pageY-e.target.lzY
					let X=originX-x
					let Y=originY-y
					// console.log('最后偏移位置',X,Y);
					//超出边界默认原点
					if( X<0||Y<0||(X+150)>width||(Y+150)>height){
						X =  0 
						Y = 0
					}
					let obj=this.sealList[index]
					obj.isUse=true
					console.log(obj);
					this.changeSealList(obj,X,Y,imageId)
					//设置已盖次数
					this.setPageNum()
					//渲染印章
					this.renderFabric()
				}
			},
			//设置已盖次数
			setPageNum(){
				let num=0
				this.sealList.forEach(item=>{
					if(item&&item.isUse==true){
						num+=item.sealArr.length
					}
					
				})
				this.applicationCoveredNum=num
			},
			//拖拽电子章结束时改变数组结构
			/**
			 * obj为当前页面信息
			 * left，top为当前电子章的定位信息
			 * imageId：当前电子章的图片url的id，通过这个id可以找到图片url
			 * **/ 
			changeSealList(obj,left,top,imageId){
				obj.sealArr.push({
					aCoords:{//四个点的坐标
						bl:{x:left,y:top+obj.height},
						br:{x:left+obj.width,y:top+obj.height},
						tl:{x:left,y:top},
						tr:{x:left+obj.width,y:top},
					},
					top: top,
					left: left,
					imageId,
					uuid:this.$lizhao.guid(),//用于拖动改变位置时需要改变对应的数组数据
				})
			},
			//取消
			cancelFn() {
				this.dialog.show = false
				this.cancel()
				clearInterval(this.CA.timer);
				clearInterval(this.device.timer)
			},
			//确定
			submitFn() {
				this.dialog.show = false
				this.confirm()
				clearInterval(this.CA.timer);
				clearInterval(this.device.timer)
			},
			show(data) {
				clearInterval(this.CA.timer);
				clearInterval(this.device.timer)
				this.dialog.show = true
				//获取企业合同详情
				this.findList()
				
			},
			// 获取企业合同详情
			findList() {
				that.GLOBAL.doGet(this.api.GLOBAL_electronic_enterprise_contract_find+'/'+this.enterpriseApplicationId, {}, (res) => {
					if (res.code == 200 && res.data) {
						if(res.data.signedList){
							res.data.signedList.forEach(item=>{
								item.signContent=JSON.parse(item.signContent)
							})
						}
						this.contractInfo=res.data
						this.applicationCoveredNum=0//已盖次数默认值为0
						//电子章图片
						this.draggable.list=[{url:'data:image/png;base64,'+res.data.sealImageData,id:res.data.id}],
						//合同pdf
						this.pdf.url=res.data.contractFile.host + res.data.contractFile.relativePath+'?Authorization='+that.userInfo.token
						// 初始化pdf
						this.initPdf()
					}else{
						this.cancelFn()
						this.contractInfo=null
						this.pdf.url=''
						this.draggable.list=[]
						this.$message.warning(res.msg)
					}
				})
			},
			//保存
			preservation(){
				//过滤出哪些页面盖了电子章
				let arr= this.sealList.filter(item=>item&&item.isUse==true)
				if(arr&&arr.length>0){
					let req={
						emulateJSON:false,// emulateJSON为前端需要参数
						enterpriseApplicationId:this.enterpriseApplicationId,
						signContent:JSON.stringify(this.sealList)
					}
					that.GLOBAL.doPost(this.api.GLOBAL_electronic_enterprise_contract_save,req, (res) => {
						if (res.code == 200) {
							that.$message.success(res.msg)
						}
					})
				}else{
					this.$message.warning('请先加盖电子印章')
				}
				
			},
			handclose() {
				this.dialog.show=false
				this.close()
				clearInterval(this.CA.timer);
				clearInterval(this.device.timer)
			},
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .el-dialog--center .el-dialog__body {
		padding: 0px 40px 0px
	}
	/deep/ .el-dialog__header{padding: 5px 10px;}
	/deep/ .el-dialog{margin: 0 auto;}
	.start{
		display: flex;justify-content: center;
	}
	
	.contractSign {
		.center {
			overflow: hidden;
			display: flex;
			justify-content: space-around;
			.c-left {
				margin-right: 20px;
				flex: 1;
				.l-t {}

				.item-li {
					width: 150px;
					height: 150px;
					padding: 6px;
					border: solid 1px #eee;
					margin-bottom: 10px;
					cursor: move;

					.image {
						width: 150px;
						height: 150px;
						overflow: hidden;
					}
				}

				.chosen {
					border: solid 1px #3089dc !important;
				}
				.checkboxList{
					.cl-top{
						max-height: 500px;overflow: auto;margin-bottom: 20px;
					}
					.usertrue{
						color: #009926;font-size: 12px;
					}
				}
				
			}

			.c-center {
				position: relative;
				.pagingSeal{
					position: absolute;left: 0;top: 0;height: 150px;width: 26px;writing-mode: vertical-lr;text-align: center;line-height: 26px;
					color: red;cursor: move;border: 1px dotted red;
				}
				
				.center-btn {
					display: flex;
					justify-content: space-between;
					padding: 10px;
					min-width: 560px;
					.lz-input{
						width: 20px;background-color: rgba(0, 0, 0, 0.8);color: #fff;text-align: center;border-radius:4px;
					}
					.lz-input::-webkit-inner-spin-button {-webkit-appearance: none!important;margin: 0!important;}
					.lz-input::-webkit-outer-spin-button {-webkit-appearance: none!important;margin: 0!important;}
				}

				#pdfCanvas {
					border: 1px solid #409EFF;
				}

				.c-cter {
					position: absolute;
					left: 0;
					top: 50px;
				}

			}
			.c-right{
				margin: 50px 0 0 20px;flex: 1;min-width: 200px;
				.r-top{
					margin-bottom:30px;
				}
				.r-center{
					margin-bottom:30px;
				}
			}

		}
		.operate{
			display: flex;margin: 10px 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/contractSign/contractSign.vue